var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hide-fields-panel" },
    [
      _c(
        "div",
        { staticClass: "panel-header" },
        [
          _c("h3", [_vm._v("Hide Fields")]),
          _vm._v(" "),
          _c("a-icon", {
            attrs: { type: "close" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "panel-actions" },
        [
          _c("a-button", { on: { click: _vm.showAllFields } }, [
            _vm._v("Show All"),
          ]),
          _vm._v(" "),
          _c("a-button", { on: { click: _vm.hideAllFields } }, [
            _vm._v("Hide All"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("a-input-search", {
        attrs: { placeholder: "Search Fields" },
        model: {
          value: _vm.searchText,
          callback: function ($$v) {
            _vm.searchText = $$v
          },
          expression: "searchText",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "fields-list" },
        _vm._l(_vm.filteredFields, function (field) {
          return _c(
            "div",
            {
              key: field._id,
              staticClass: "field-item",
              on: {
                click: function ($event) {
                  return _vm.toggleField(field)
                },
              },
            },
            [
              _c("a-checkbox", {
                attrs: { checked: !_vm.isFieldHidden(field._id) },
                on: {
                  change: function ($event) {
                    $event.stopPropagation()
                    return _vm.toggleField(field)
                  },
                },
              }),
              _vm._v(" "),
              _c("i", { staticClass: "material-icons" }, [
                _vm._v(_vm._s(_vm.getIcon(field))),
              ]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(field.name))]),
            ],
            1
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }